import request from '../request'
export default {
  // 商品分类以及商品列表
  shopCartList: function () {
    return request.Post('v1/shop/shopCartList', {
    })
        .then((response) => {
          return response
        })
        .catch((error) => {
          return error
        })
  },
  listStore: function (param) {
    return request.Post('shop/listStore', {
      id: param
    })
        .then((response) => {
          return response
        })
        .catch((error) => {
          return error
        })
  },
  // 提交订单
  // {[
  // 	orderPrice:订单价格,
  // 	goodsName:商品名json,
  // 	imgPath:图片json,
  // 	remark:备注,
  // 	orderItemList:[
  // 		goodsId:商品ID
  // 		goodsName:商品名称,
  // 		goodsPrice:商品价格,
  // 		qty:商品数量
  // 	]
  // ]}
  createOrder: function (param) {
    return request.Post('shop/createOrder', {
      orderPrice: param.orderPrice,
      goodsName: param.goodsName || '',
      containerLoadId: param.containerLoadId || '',
      imgPath: param.imgPath || '',
      remark: param.remark || '',
      orderItemList: param.orderItemList || [],
    })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  }
}
